import { always, append, compose, equals, when } from 'ramda';
import { useFormContext } from 'react-hook-form';
import { GranteeTypeEnum } from '@fasstech/oip-core/entities/Grantee/enums';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';

const useGranteeForm = ({
  index,
  isDisabledAddingChild,
  isDisabledAddingSpouse,
  getMiddleText
}) => {
  const form = useFormContext();

  const grantees = form.watch('grantees');

  const granteeDisabledTypes = compose(
    when(always(isDisabledAddingSpouse(grantees)), append(GranteeTypeEnum.SPOUSE)),
    when(always(isDisabledAddingChild(grantees)), append(GranteeTypeEnum.CHILD))
  )([]);

  const granteeType = form.watch(`grantees.${index}.type`);

  const granteeIsChild = equals(granteeType, GranteeTypeEnum.CHILD);
  const granteeIsSpouse = equals(granteeType, GranteeTypeEnum.SPOUSE);

  const getFieldsName = (name) => `grantees.${index}.${name}`;

  const id = form.watch(`grantees.${index}.id`);

  const granteeTypeIsEmpty =
    isNilOrEmpty(getMiddleText('BENEFICIAIRE_TYPE_CHILD_LABEL')) ||
    isNilOrEmpty(getMiddleText('BENEFICIAIRE_TYPE_SPOUSE_LABEL'));

  return {
    id,
    getFieldsName,
    form,
    granteeDisabledTypes,
    granteeType,
    granteeIsChild,
    granteeIsSpouse,
    granteeTypeIsEmpty
  };
};

export default useGranteeForm;
